document.addEventListener('DOMContentLoaded', function() {
  // Reveal on scroll
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length > 0) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: .15 });
    revealEls.forEach(el => io.observe(el));
  }
});

// Custom Accordion Logic (Global Delegate)
if (!window.customAccordionInit) {
  window.customAccordionInit = true;
  document.addEventListener('click', function(e) {
    const header = e.target.closest('.custom-accordion-header');
    if (!header) return;
    
    const item = header.closest('.custom-accordion-item');
    const contentWrapper = item.querySelector('.custom-accordion-content-wrapper');
    const contentInner = item.querySelector('.custom-accordion-content-inner');
    const isExpanded = header.getAttribute('aria-expanded') === 'true';
    
    if (isExpanded) {
      // Close it
      contentWrapper.style.height = contentWrapper.scrollHeight + 'px';
      // Force reflow
      void contentWrapper.offsetHeight;
      contentWrapper.style.height = '0px';
      header.setAttribute('aria-expanded', 'false');
    } else {
      // Open it
      contentWrapper.style.display = 'block';
      contentWrapper.style.height = contentInner.offsetHeight + 'px';
      header.setAttribute('aria-expanded', 'true');
      
      // After transition, set to auto so it responds to resize smoothly
      setTimeout(() => {
        if (header.getAttribute('aria-expanded') === 'true') {
          contentWrapper.style.height = 'auto';
        }
      }, 350);
    }
  });
}
